module.exports = __webpack_public_path__ + "img/picto-payment.dbc1bd67.svg";